import {API_URL} from "../../constants/CONST";
import {GameMode} from "../../models/GameMode";
import {Difficulty} from "../../models/Difficulty";
import {ApiClass} from "./ApiClass";
import {GameModeOptions} from "../../data/gameModeOptions";


class GameApiClass extends ApiClass {

    async getText(difficulty : Number): Promise<string[]> {
        try {
            const res = await fetch(API_URL + "/getText/difficulty="+difficulty, {
                method: "GET",
                headers: this.jsonHeader
            })

            const data = await res.json()
            return data.text.map((element: string) => {
                return element.charAt(0).toLowerCase() + element.slice(1);
            })
        } catch (e) {
            return []
        }
    }

    async getGameTheme() : Promise<GameMode[]>{
        try {
            const res = await fetch(API_URL + "/gameTheme", {
                method: "GET",
                headers: this.jsonHeader
            })

            return await res.json()
        } catch (e) {
            return []
        }
    }

    async getGameThemesNameById(id: number) : Promise<string>{
        try {
            const res = await fetch(API_URL + "/gameTheme/"+id, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            })

            const data = await res.json()
            return data.name
        } catch (e) {
            return ""
        }
    }

    async getAllGameModes() : Promise<GameMode[]>{
        try {
            const res = await fetch(API_URL + "/gameMode", {
                method: "GET",
                headers: this.jsonHeader
            })

            return await res.json()
        } catch (e) {
            return []
        }
    }

    async getGameModeFromTheme(id: number) : Promise<GameMode[]>{
        try {
            const res = await fetch(API_URL + "/gameMode/gameThemeId="+id, {
                method: "GET",
                headers: this.jsonHeader
            })

            return await res.json()
        } catch (e) {
            return []
        }
    }

    async getGameModeFromDifficulty(id: number) : Promise<Difficulty[]>{
        try {
            const res = await fetch(API_URL + "/gameMode/difficulty/"+id, {
                method: "GET",
                headers: this.jsonHeader
            })
            let result = await res.json()

            return result.map((element: any) => {
                return new Difficulty(element.difficulty.name, element.idGameMode, element.idDifficulty)
            })
        } catch (e) {
            return []
        }
    }
    
    async getGameModeOptions(): Promise<GameModeOptions> {
        try {
            const res = await fetch(API_URL + "/gameModeOptions", {
                method: "GET",
                headers: this.jsonHeader
            });

            const data = await res.json()
            return new GameModeOptions(data);
        } catch (e) {
            return new GameModeOptions();
        }
    }

    async getSoloClassicGameMode(): Promise<GameMode[]>  {
        try {
            const res = await fetch(API_URL + "/gameMode/soloClassic", {
                method: "GET",
                headers: this.jsonHeader
            });

            return await res.json();
        } catch (e) {
            return [];
        }
    }
}

export const GameApi = new GameApiClass();
